import { render } from "./PasarelaProductosSelector.vue?vue&type=template&id=951050c8&scoped=true"
import script from "./PasarelaProductosSelector.vue?vue&type=script&lang=js"
export * from "./PasarelaProductosSelector.vue?vue&type=script&lang=js"

import "./PasarelaProductosSelector.vue?vue&type=style&index=0&id=951050c8&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-951050c8"]])

export default __exports__